<script lang="ts">
  import DepartmentGoals from "./DepartmentGoals.svelte"
  import { appStore } from "$app/store.svelte"

  let deptsWithGoals: DepartmentType[] = $state([])
  let deptsNoGoals: DepartmentType[] = $state([])

  let { expanded = $bindable(false) }: { expanded: boolean } = $props()

  appStore.departments
    .filter((d) => {
      if (
        Array.isArray(appStore.goalParams.department) &&
        appStore.goalParams.department.length
      ) {
        return appStore.goalParams.department.includes(d.id)
      }
      return true
    })
    .forEach((d) => {
      if (appStore.goals.filter((g) => g.assignee_id === d.id).length > 0) {
        deptsWithGoals.push(d)
      } else {
        deptsNoGoals.push(d)
      }
    })
</script>

{#each [...deptsWithGoals, ...deptsNoGoals] as department (department.id)}
  <DepartmentGoals {department} {expanded} />
{/each}
